import React, { useMemo, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useOrganizations from 'src/dataHooks/useOrganizations';
import useBanks from 'src/dataHooks/useBanks';
import PageSpin from 'src/components/PageSpin';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import HelpLink from 'src/components/HelpLink';
import Form from './Form';
import styles from './styles.module.scss';

// Если организация передана через роутер при навигации с предыдущей страницы,
// то дополнительно ничего грузить не надо, но возможен вариант перехода по прямой ссылке
// или обратного редиректа из авторизации, тогда данные нужно загрузить
const useOrganization = () => {
  const { organizations, fetchOrganizations } = useOrganizations();
  const location = useLocation();
  const params = useParams();

  const organization = useMemo(
    () =>
      location.state?.organization ||
      organizations?.find(
        ({ organizationUeid }: any) => organizationUeid === params.organizationUeid
      ),
    [location.state, params.organizationUeid, organizations]
  );

  useEffect(() => {
    if (!location.state?.organization) {
      fetchOrganizations();
    }
  }, [fetchOrganizations, location.state]);

  return organization;
};

const AddBank: React.FC = () => {
  const organization = useOrganization();
  const { banks, fetchBanks, wasBanksFetched } = useBanks();

  useEffect(() => {
    fetchBanks();
  }, [fetchBanks]);

  // Банки запрашиваются на уровне страницы а не формы из-за двухфаторки.
  // Если загружать на уровне формы и прав доступа не хватает, то перед навигацией
  // на страницу двухфаторки успеет мелькнуть текст.
  if (!organization || !wasBanksFetched) {
    return <PageSpin />;
  }

  return (
    <ContentLayout size="small">
      <HelpLink className={styles['help']}/>
      <Text type="h2" className={styles['title']}>Добавление банка</Text>
      <Text type="p">
        для организации {organization.name} (ИНН {organization.inn}, ОГРН {organization.ogrn})
      </Text>
      <Form banks={banks} organization={organization} />
    </ContentLayout>
  );
};

export default AddBank;
